<template>
    <div>
        <b-row>
            <b-col lg="6">
                <b-form-group label="First Name" label-class="text-truncate">
                    <b-form-input v-model="firstName"/>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="Last Name" label-class="text-truncate">
                    <b-form-input v-model="lastName"/>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="6">
                <b-form-group label="Work Number" label-class="text-truncate">
                    <b-form-input v-model="phoneNumber"/>
                </b-form-group>
            </b-col>
            <b-col lg="6">
                <b-form-group label="Company Name" label-class="text-truncate">
                    <b-form-input v-model="companyName"/>
                </b-form-group>
            </b-col>
        </b-row>

        <b-form-group label="Email" label-class="text-truncate label-required">
            <b-form-input v-model="email" required/>
        </b-form-group>

        <b-form-group label="Website URL" label-class="text-truncate">
            <b-form-input v-model="websiteUrl"/>
        </b-form-group>

        <b-form-group label="Username" label-class="text-truncate">
          <b-form-input v-model="slug" maxlength="20"/>
        </b-form-group>

        <b-row>
            <b-col lg="3">
                <b-form-group label="COUNTRY" label-class="text-truncate label-required">
                    <country-select class="form-control"
                                    v-model="country"
                                    :country="country"
                                    topCountry="US"
                                    required
                                    :countryName="true"/>
                </b-form-group>
            </b-col>

            <b-col lg="3">
                <b-form-group label="STATE" label-class="text-truncate label-required">
                    <region-select :regionName="true"
                                   :countryName="true"
                                   class="form-control"
                                   v-model="state"
                                   required
                                   :country="country"
                                   :region="state"/>
                </b-form-group>
            </b-col>

            <b-col lg="3">
                <b-form-group label="Postal Code" label-class="text-truncate label-required">
                    <b-form-input v-model="postalCode" required/>
                </b-form-group>
            </b-col>

            <b-col lg="3">
                <b-form-group label="City" label-class="text-truncate label-required">
                    <b-form-input v-model="city" required/>
                </b-form-group>
            </b-col>
        </b-row>

        <b-form-group label="Mailing Address Line 1" label-class="text-truncate label-required">
            <b-form-input v-model="mailingLine1" required/>
        </b-form-group>

        <b-form-group label="Mailing Address Line 2" label-class="text-truncate">
            <b-form-input v-model="mailingLine2"/>
        </b-form-group>

        <b-row>
            <b-col lg="6" v-for="link in user.available_social_links">
                <b-form-group :label="humanize(link)" label-class="text-truncate">
                    <b-form-input v-model="socialLinks[link]"/>
                    <div class="font-size-sm text-muted mt-1">
                        {{socialPreviewLink(link, socialLinks[link])}}
                    </div>
                </b-form-group>
            </b-col>
        </b-row>

        <b-form-group label="I'm available for Assignments" label-class="text-truncate">
            <b-form-checkbox v-model="availableForAssignments" switch/>
        </b-form-group>

    </div>
</template>

<script>
  import SwitchInput from "../../Common/SwitchInput";
  import GeneralMixins from "../../../mixins/GeneralMixins";

  export default {
    components: {SwitchInput},
    mixins: [GeneralMixins],
    props: ['user'],

    data: function () {
      return {
        firstName: null,
        lastName: null,
        phoneNumber: null,
        companyName: null,
        websiteUrl: null,
        country: null,
        state: null,
        city: null,
        postalCode: null,
        mailingLine1: null,
        mailingLine2: null,
        socialLinks: {},
        availableForAssignments: null,
        email: null,
        slug: null,
      }
    },

    created() {
      this.resetForm();
    },

    methods: {
      resetForm() {
        console.log(this.user);

        this.firstName = this.user.first_name;
        this.lastName = this.user.last_name;
        this.phoneNumber = this.user.phone_number;
        this.companyName = this.user.company_name;
        this.websiteUrl = this.user.website_url;
        this.country = this.user.country;
        this.state = this.user.state;
        this.city = this.user.city;
        this.postalCode = this.user.postal_code;
        this.mailingLine1 = this.user.mailing_address_line_1;
        this.mailingLine2 = this.user.mailing_address_line_2;
        this.socialLinks = this.user.social_links || {};
        this.availableForAssignments = this.user.available_for_assignments;
        this.email = this.user.email;
        this.slug = this.user.slug;
      },

      socialPreviewLink(platform, val) {
        if (!val || (val && val === '')) {
          return '';
        } else if (val.includes('http')) {
          return val;
        } else {
          return `https://${platform}.com/${val}`
        }
      }
    },

    computed: {
      params() {
        return {
          first_name: this.firstName,
          last_name: this.lastName,
          phone_number: this.phoneNumber,
          company_name: this.companyName,
          website_url: this.websiteUrl,
          country: this.country,
          state: this.state,
          city: this.city,
          postal_code: this.postalCode,
          mailing_address_line_1: this.mailingLine1,
          mailing_address_line_2: this.mailingLine2,
          social_links: this.socialLinks,
          available_for_assignments: this.availableForAssignments,
          email: this.email,
          slug: this.slug
        }
      }
    }
  }
</script>